// organizationActions.js
import {
  FETCH_ORGANIZATIONS_REQUEST,
  FETCH_ORGANIZATIONS_SUCCESS,
  FETCH_ORGANIZATIONS_FAILURE,
  CREATE_ORGANIZATION_REQUEST,
  CREATE_ORGANIZATION_SUCCESS,
  CREATE_ORGANIZATION_FAILURE,
  UPDATE_ORGANIZATION_REQUEST,
  UPDATE_ORGANIZATION_SUCCESS,
  UPDATE_ORGANIZATION_FAILURE,
  CLEAR_ORGANIZATION_STATE,
  SET_ACTIVE_ORGANIZATION,
  RESET_ORG_FLAG,
  SET_CONSOLIDATED_VIEW,
} from "./actionTypes"

// Fetch Organizations Actions
export const fetchOrganizationsRequest = () => ({
  type: FETCH_ORGANIZATIONS_REQUEST,
})

export const clearOrganizationState = () => ({
  type: CLEAR_ORGANIZATION_STATE,
  payload: null,
})

export const fetchOrganizationsSuccess = organizations => ({
  type: FETCH_ORGANIZATIONS_SUCCESS,
  payload: organizations,
})

export const fetchOrganizationsFailure = error => ({
  type: FETCH_ORGANIZATIONS_FAILURE,
  payload: error,
})

// Create Organization Actions
export const createOrganizationRequest = organizationData => ({
  type: CREATE_ORGANIZATION_REQUEST,
  payload: organizationData,
})

export const createOrganizationSuccess = organization => ({
  type: CREATE_ORGANIZATION_SUCCESS,
  payload: organization,
})

export const createOrganizationFailure = error => ({
  type: CREATE_ORGANIZATION_FAILURE,
  payload: error,
})

export const updateOrganizationRequest = organizationData => ({
  type: UPDATE_ORGANIZATION_REQUEST,
  payload: { organizationData },
})

export const updateOrganizationSuccess = updatedOrganization => ({
  type: UPDATE_ORGANIZATION_SUCCESS,
  payload: updatedOrganization,
})

export const resetOrgFlag = error => {
  return {
    type: RESET_ORG_FLAG,
  }
}

export const updateOrganizationFailure = error => ({
  type: UPDATE_ORGANIZATION_FAILURE,
  payload: error,
})

export const setActiveOrganization = organization => ({
  type: SET_ACTIVE_ORGANIZATION,
  payload: organization,
})

export const setConsolidatedView = value => ({
  type: SET_CONSOLIDATED_VIEW,
  payload: value,
})
